module.exports = __webpack_public_path__ + "img/coupon_bg.4cef25d.png";